module.exports = __webpack_public_path__ + "img/sonoras.38561757.png";